//const apiUrl = 'https://fitspark-api.orbitnapp.com/';
//const apiUrl = 'http://31.97.227.191:3004/';
const apiUrl = 'https://api.myfitspark.com/';
const apiUrlAdmin = 'https://admin.myfitspark.com/api/';
export const GOOGLE_CLIENT_ID = '243295492072-pgkmj91j5pii6kmquf8hqbskmvs6s2di.apps.googleusercontent.com';
export const FACEBOOK_APP_ID = '2548407618893586';
export const API_URL_Admin = apiUrlAdmin;
export const API_URL = apiUrl;